// Use namespace import to avoid TS named export resolution issues with moduleResolution Bundler
import * as TiptapCore from '@tiptap/core';
const { mergeAttributes } = TiptapCore as any;

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    iframe: {
      insertIframe: (options: { src: string; width?: number; height?: number; allowfullscreen?: boolean | string; frameborder?: number | string }) => ReturnType;
    };
  }
}

export const Iframe = (TiptapCore as any).Node.create({
  name: 'iframe',
  group: 'block',
  atom: true,
  draggable: true,
  selectable: true,
  addAttributes() {
    return {
      src: { default: null },
      width: { default: 640 },
      height: { default: 360 },
      frameborder: { default: 0 },
      allowfullscreen: { default: true }
    };
  },
  parseHTML() {
    return [{ tag: 'iframe' }];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      'iframe',
      mergeAttributes(
        { class: 'rte-video iframe-embed ratio ratio-16x9' },
        { ...HTMLAttributes, allowfullscreen: HTMLAttributes.allowfullscreen ? 'true' : null }
      )
    ];
  },
  addCommands() {
    return {
      insertIframe:
        (options) => ({ commands }) => {
          if (!options.src) return false;
          return commands.insertContent({ type: this.name, attrs: options });
        }
    };
  }
});

export default Iframe;